import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-add-group',
  templateUrl: 'addGroup.html',
  providers : [HttpClient, CustomToast]
})
export class AddGroupPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  group = {
    name_es : '',
    name_en : '',
    description_es : '',
    description_en : '',
    image : '',
    coordinator_id : -1
  };

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  customToast : CustomToast;
  events : Events;

  users;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.httpCallPeople('',1000);
	}

  httpCallPeople(name,max){
    this.httpClient.get('/users?name='+name+'&max='+max,(error,data)=>{
      this.users = data.json();
    });
  }

  httpPostGroup(){
    if(!this.group.name_es || !this.group.description_es || ! this.group.coordinator_id){
      this.customToast.showMessage('Los campos con * son necesarios',2000);
    }else{
      this.httpClient.post('/groups',this.group,(error,data)=>{
        if(!error){
          let response = data._body
          const groupId = +(response.substring( 0, response.indexOf(",")).split('[')[1])
          this.httpPutCoordinatorGroup(groupId)
        }
      });
    }
    
  }

  httpPutCoordinatorGroup(groupId){
    this.httpClient.put('/users/group/'+this.group.coordinator_id, {groupId},(error,data)=>{
      if(!error){
      this.customToast.showMessage('Grupo creado correctamente',2000);
      this.navCtrl.pop();
      this.events.publish('addGroup:done');
      }
    });
  }

  onClickSave(){
    this.httpPostGroup();
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.group.image = image.filename;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/groups/addGroup/addGroup.ts